import translate from '@translate';
import React, { FC, useState, useEffect, ReactNode, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Typography from 'src/components/Typography';
import { RootStoreType } from 'src/types/store';
import TableSimple from 'src/components/TableSimple';
import { OrderIcon } from 'src/components/SkladonIcon/Icons';
import { useCheckPermission } from 'src/utils/checkPermission';
import { allColumns } from './constants';
import { getOverviewOrdersGridFetch } from 'src/resources/overviewOrdersGrid/reducer';
import { TableColumnType, TableRowType } from 'src/types/table';
import { OrderType } from 'src/types/order';
import { getStatusIcon } from 'src/containers/OrderDetailContainer/functions';
import StatusLabel from 'src/components/StatusLabel';
import useInView from 'src/utils/useInView';

const getReason = (order: OrderType): string => {
    if (order.STATUS === 'productsNotAvailable') {
        return translate('overview.ordersReason.productsNotAvailable');
    }
    if (order.STATUS === 'incorrect') {
        return translate('overview.ordersReason.incorrect');
    }
    return '';
};

const OrdersContainer: FC<{ mobile?: boolean }> = (props) => {
    const dispatch = useDispatch();
    const containerRef = useRef<HTMLDivElement>(null);
    const inView = useInView(containerRef, { rootMargin: '100px' });
    const ordersData = useSelector((state: RootStoreType) => state.overviewOrdersGrid.data);
    const loading = useSelector((state: RootStoreType) => state.overviewOrdersGrid.loading);
    const orderStatusCodesObject = useSelector(
        (state: RootStoreType) => state.constantsCodes.objects.orderStatusCodes
    );

    const [formatedData, setFormatedData] = useState<TableRowType[]>([]);

    useEffect(() => {
        if (ordersData?.data) {
            setFormatedData(
                ordersData.data.map((order) => ({
                    ...order,
                    reason: getReason(order),
                    waitingDays: Math.floor(
                        (new Date().getTime() - new Date(order.TIMESTAMP || '').getTime()) / (1000 * 3600 * 24)
                    ),
                }))
            );
        }
    }, [ordersData?.data]);
    const permissionOrderDetail = useCheckPermission('ORDER.DETAIL');

    useEffect(() => {
        if (inView) {
            dispatch(getOverviewOrdersGridFetch());
        }
    }, [inView, dispatch]);

    const customRender = (column: TableColumnType, row: TableRowType): ReactNode | undefined => {
        if (column.key === 'reason') {
            return (
                <StatusLabel
                    icon={getStatusIcon(row.STATUS)}
                    label={row.reason}
                    color={orderStatusCodesObject[row.STATUS]?.color}
                />
            );
        }
        return undefined;
    };

    return (
        <div ref={containerRef}>
            <Typography variant="h6" gutterBottom>
                {translate('overview.ordersAttention')}
            </Typography>
            <TableSimple
                initSort={{ column: 'TIMESTAMP', direction: 'ASC' }}
                allColumns={allColumns}
                rowIdKey="ID"
                rows={formatedData}
                loading={loading || !inView}
                columsLabelPrefix="orders.table"
                customRender={customRender}
                rowActions={[
                    {
                        icon: <OrderIcon />,
                        label: translate('orders.action.orderDetail'),
                        getLink: (row) => `/orders/${row.ID}/`,
                        hiddenFce: () => !permissionOrderDetail,
                    },
                ]}
                selectOptions={{}}
                disableFilter
                sx={
                    props.mobile
                        ? { '& .MuiPaper-root': { maxHeight: '300px' } }
                        : {
                              width: '100%',
                              height: 'calc(100% - 35px)',
                              position: 'absolute',
                              '& .MuiPaper-root': { maxHeight: 'calc(100% - 45px)' },
                          }
                }
            />
        </div>
    );
};

export default OrdersContainer;
